import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const PaymentMethodBreakdown = ({ data }) => {
  const COLORS = {
    cash: '#10b981',
    card: '#3b82f6',
    digital_wallet: '#8b5cf6',
    member_account: '#f59e0b'
  };

  const paymentMethodLabels = {
    cash: 'Cash',
    card: 'Card',
    digital_wallet: 'Digital Wallet',
    member_account: 'Member Account'
  };

  const paymentMethodIcons = {
    cash: 'Banknote',
    card: 'CreditCard',
    digital_wallet: 'Smartphone',
    member_account: 'User'
  };

  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Payment Method Breakdown</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="CreditCard" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No payment data available</p>
        </div>
      </div>
    );
  }

  const chartData = data?.map(item => ({
    name: paymentMethodLabels?.[item?.method] || item?.method,
    value: item?.amount,
    count: item?.count,
    method: item?.method
  }));

  const formatCurrency = (value) => `$${value?.toFixed(2)}`;

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Payment Method Breakdown</h2>
        <Icon name="PieChart" size={20} className="text-primary" />
      </div>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS?.[entry?.method] || '#94a3b8'} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-6 space-y-3">
        {data?.map((item) => (
          <div key={item?.method} className="flex items-center justify-between p-3 bg-accent/30 rounded-lg">
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${COLORS?.[item?.method] || '#94a3b8'}20` }}
              >
                <Icon
                  name={paymentMethodIcons?.[item?.method] || 'DollarSign'}
                  size={20}
                  style={{ color: COLORS?.[item?.method] || '#94a3b8' }}
                />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">
                  {paymentMethodLabels?.[item?.method] || item?.method}
                </p>
                <p className="text-xs text-muted-foreground">{item?.count} transactions</p>
              </div>
            </div>
            <p className="text-sm font-semibold text-foreground">${item?.amount?.toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodBreakdown;